import { useState } from "react"
import { Container } from "reactstrap"
import Tabs from "../../../../components/common/Tabs/Tabs"
import ManageUsers from "./ManageUsers/ManageUsers"
import RoleAndPermissions from "./RoleAndPermissions/RoleAndPermissions"
import InviteNewUser from "./InviteNewUser/InviteNewUser"

const User = () => {

  const tabs = ['Manage Users', 'Role and Permissions', 'Invite New User']
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh", paddingBlock: "1rem" }}>
      <Container fluid>
        <div className="fw-semibold fs-4">User</div>

        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />


        {activeTab === 'Manage Users' && <ManageUsers />}
        {activeTab === 'Role and Permissions' && <RoleAndPermissions />}
        {activeTab === 'Invite New User' && <InviteNewUser />}

      </Container>
    </div>
  )
}

export default User
